/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./oAuthLogin.vue?vue&type=template&id=f0edde20&scoped=true&"
import script from "./oAuthLogin.vue?vue&type=script&lang=js&"
export * from "./oAuthLogin.vue?vue&type=script&lang=js&"
import style0 from "./oAuthLogin.vue?vue&type=style&index=0&id=f0edde20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0edde20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VBtn,VCheckbox})
